var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v("数据看板/运营看板/运营分析")
      ]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("div", [
            _c(
              "div",
              { staticClass: "title-item mr20" },
              [
                _c(
                  "el-tag",
                  {
                    staticClass: "mr20 analysis-tag",
                    attrs: { size: "large", type: "danger" }
                  },
                  [_vm._v("时效分析")]
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "analysis-header" }, [
            _c("div", { staticClass: "analysis-item" }, [
              _c("div", { staticClass: "title-item" }, [_vm._v("待派发")]),
              _c("div", { staticClass: "stats" }, [
                _c("div", { staticClass: "stat-group" }, [
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.pendingDispatchStats.workOrderCount))
                  ]),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("工单数")])
                ]),
                _c("div", { staticClass: "stat-group" }, [
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.pendingDispatchStats.deviceCount))
                  ]),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("涉及设备")])
                ])
              ])
            ]),
            _c("div", { staticClass: "analysis-item" }, [
              _c("div", { staticClass: "title-item" }, [_vm._v("超时")]),
              _c("div", { staticClass: "stats" }, [
                _c("div", { staticClass: "stat-group" }, [
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.overtimeStats.workOrderCount))
                  ]),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("工单数")])
                ]),
                _c("div", { staticClass: "stat-group" }, [
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.overtimeStats.deviceCount))
                  ]),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("涉及设备")])
                ])
              ])
            ]),
            _c("div", { staticClass: "analysis-item" }, [
              _c("div", { staticClass: "title-item" }, [_vm._v("质量问题")]),
              _c("div", { staticClass: "stats" }, [
                _c("div", { staticClass: "stat-group" }, [
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.qualityIssueStats.workOrderCount))
                  ]),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("工单数")])
                ]),
                _c("div", { staticClass: "stat-group" }, [
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.qualityIssueStats.deviceCount))
                  ]),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("涉及设备")])
                ])
              ])
            ])
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", "margin-top": "20px" },
              attrs: { data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "workOrderId", label: "工单号" }
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "工单状态" }
              }),
              _c("el-table-column", {
                attrs: { prop: "type", label: "工单类型" }
              }),
              _c("el-table-column", {
                attrs: { prop: "handler", label: "当前处理人" }
              }),
              _c("el-table-column", {
                attrs: { prop: "stage", label: "当前阶段" }
              }),
              _c("el-table-column", {
                attrs: { prop: "overtime", label: "超时时间" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("el-card", { staticClass: "box-card" }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "title-item mr20" },
            [
              _c(
                "el-tag",
                {
                  staticClass: "mr20 analysis-tag",
                  attrs: { size: "large", type: "danger" }
                },
                [_vm._v("人效分析")]
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "analysis-content" }, [
          _c("div", { staticClass: "data-section" }, [
            _c("div", { staticClass: "section-title" }, [_vm._v("服务器搬迁")]),
            _c("div", { staticClass: "section-subtitle" }, [
              _vm._v(_vm._s(_vm.serverRelocationPerPersonStats) + "台/人天")
            ]),
            _c(
              "div",
              { staticClass: "data-list" },
              _vm._l(_vm.serverRelocationStats, function(value, location) {
                return _c("div", { key: location, staticClass: "data-item" }, [
                  _c("span", { staticClass: "location" }, [
                    _vm._v(_vm._s(location))
                  ]),
                  _c("span", { staticClass: "value" }, [_vm._v(_vm._s(value))])
                ])
              }),
              0
            )
          ]),
          _c("div", { staticClass: "chart-section" }, [
            _c(
              "div",
              { staticClass: "bar-chart" },
              _vm._l(_vm.serverRelocationStats, function(value, location) {
                return _c(
                  "div",
                  {
                    key: location,
                    staticClass: "bar",
                    style: {
                      height:
                        (value /
                          Math.max.apply(
                            Math,
                            Object.values(_vm.serverRelocationStats)
                          )) *
                          100 +
                        "%"
                    }
                  },
                  [
                    _c("div", { staticClass: "bar-value" }, [
                      _vm._v(_vm._s(value))
                    ]),
                    _c("div", { staticClass: "bar-label" }, [
                      _vm._v(_vm._s(location))
                    ])
                  ]
                )
              }),
              0
            )
          ])
        ]),
        _c("div", { staticClass: "analysis-content" }, [
          _c("div", { staticClass: "data-section" }, [
            _c("div", { staticClass: "section-title" }, [_vm._v("TPC部署")]),
            _c("div", { staticClass: "section-subtitle" }, [
              _vm._v(_vm._s(_vm.tpcDeploymentPerPersonStats) + "台/人天")
            ]),
            _c(
              "div",
              { staticClass: "data-list" },
              _vm._l(_vm.tpcDeploymentStats, function(value, location) {
                return _c("div", { key: location, staticClass: "data-item" }, [
                  _c("span", { staticClass: "location" }, [
                    _vm._v(_vm._s(location))
                  ]),
                  _c("span", { staticClass: "value" }, [_vm._v(_vm._s(value))])
                ])
              }),
              0
            )
          ]),
          _c("div", { staticClass: "chart-section" }, [
            _c(
              "div",
              { staticClass: "bar-chart" },
              _vm._l(_vm.tpcDeploymentStats, function(value, location) {
                return _c(
                  "div",
                  {
                    key: location,
                    staticClass: "bar",
                    style: {
                      height:
                        (value /
                          Math.max.apply(
                            Math,
                            Object.values(_vm.tpcDeploymentStats)
                          )) *
                          100 +
                        "%"
                    }
                  },
                  [
                    _c("div", { staticClass: "bar-value" }, [
                      _vm._v(_vm._s(value))
                    ]),
                    _c("div", { staticClass: "bar-label" }, [
                      _vm._v(_vm._s(location))
                    ])
                  ]
                )
              }),
              0
            )
          ])
        ]),
        _c("div", { staticClass: "analysis-content" }, [
          _c("div", { staticClass: "data-section" }, [
            _c("div", { staticClass: "section-title" }, [
              _vm._v("网络特殊变更")
            ]),
            _c("div", { staticClass: "section-subtitle" }, [
              _vm._v(_vm._s(_vm.networkChangePerPersonStats) + "台/人天")
            ]),
            _c(
              "div",
              { staticClass: "data-list" },
              _vm._l(_vm.networkChangeStats, function(value, location) {
                return _c("div", { key: location, staticClass: "data-item" }, [
                  _c("span", { staticClass: "location" }, [
                    _vm._v(_vm._s(location))
                  ]),
                  _c("span", { staticClass: "value" }, [_vm._v(_vm._s(value))])
                ])
              }),
              0
            )
          ]),
          _c("div", { staticClass: "chart-section" }, [
            _c(
              "div",
              { staticClass: "bar-chart" },
              _vm._l(_vm.networkChangeStats, function(value, location) {
                return _c(
                  "div",
                  {
                    key: location,
                    staticClass: "bar",
                    style: {
                      height:
                        (value /
                          Math.max.apply(
                            Math,
                            Object.values(_vm.networkChangeStats)
                          )) *
                          100 +
                        "%"
                    }
                  },
                  [
                    _c("div", { staticClass: "bar-value" }, [
                      _vm._v(_vm._s(value))
                    ]),
                    _c("div", { staticClass: "bar-label" }, [
                      _vm._v(_vm._s(location))
                    ])
                  ]
                )
              }),
              0
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }